export default "__VITE_ASSET__e5e92078__"